import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import EstateMpProvider from "@/core/data-provider/data-mp/estate/estate-mp-provider";
import useAppSelector from "@/core/helpers/useAppSelector";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import { estateSelector, setInfoIsResident } from "@/domains/estate/slice";
import toast from "@/domains/toasts/helpers/toast";

export default function useSetResident({ setIsShow }) {
  const { t } = useTranslation("estate");
  const estate = useAppSelector(estateSelector);
  const dispatch = useDispatch();
  const [pending, setPending] = useState(false);

  const setResident = useCallback(async () => {
    if (estate.isResident) {
      toast.error(t(`estate.resident.errors.SAME_ENTITY_ERROR`));
      return;
    }

    setPending(true);

    await EstateMpProvider.setResident(estate.id)
      .then((response) => {
        if (response instanceof RpcMpProviderSuccessResponse) {
          dispatch(setInfoIsResident(true));
          toast.success(t("estate.resident.success", { address: estate.address }));
          setIsShow(false);
        } else {
          console.error(response);
          toast.error(t(`estate.resident.errors.${response.error.message}`));
          setIsShow(false);
        }
      })
      .catch((e) => {
        console.error(e);
        toast.error(t("estate.resident.errors.default"));
        setIsShow(false);
      })
      .finally(() => {
        setPending(false);
      });
  }, [dispatch, estate.address, estate.id, estate.isResident, setIsShow, t]);

  return {
    pending,
    setResident,
  };
}
